import React, { useEffect, useState } from 'react';
import { useTheme, ITheme } from 'src/theme';
import { css } from '@linaria/core';
import { useAvivaSelector } from '@redux/hook';
import { SQSPocketResponse } from '@models/SQSPocketRequest.model';
import { Helpers } from '@utils/helpers';
import { GAAviva } from '@utils/gaAviva';


import ContainerBlock from '@components/ContainerBlock';
import Heading from '@components/Heading';
import Text from '@components/Text';
import Listing from '@components/Listing';
import ContactBox from '@components/ContactBox';
import Divider from '@components/Divider';
import { LeftGrid, FullGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import Link from '@components/Link';


const fluidBox = css`
  margin-top: -40px;
`;

const marginTop = css`
  @media screen and (min-width: 768px) {
    margin-top: 30px
  }
`;

const trackOnload = (): void => {
  const GA = GAAviva.getInstance();
  let { form } = GA.digitalData;
  form.name = "";
  GA.trackPageLoad({ form });
}


export interface ThankYouProps { }

function ThankYou(props: ThankYouProps) {
  const contactInformation = useAvivaSelector(state => state.staticData.contactInformation);
  const policyNo = useAvivaSelector(state => state.sioStep5.policyNo);
  const quoteRawResponse = useAvivaSelector(state => state.sioStep1.quoteRawResponse);
  const [summaries, setSummaries] = useState<any>(undefined);

  useEffect(() => {
    const quotation: SQSPocketResponse = new SQSPocketResponse(quoteRawResponse);
    if (summaries === undefined && quoteRawResponse) {
      const data = [
        { text: 'Policy number', value: policyNo },
        ...quotation.sioPlanDetailsSummary,
        { text: 'Premium payment method', value: 'Credit Card', fontWeight: 'bold' }
      ]
      setSummaries(data);
      trackOnload();
    }
    Helpers.clearCached();
  }, [quoteRawResponse, summaries, setSummaries, policyNo]);

  const theme: ITheme = useTheme();
  return (
    <Container>
      <ContainerBlock className={fluidBox} background={theme.colors.secondary} padding="40px 0" paddingTablet="130px 0 110px 30px">
        <ContainerGrid>
          <FullGrid>
            <LeftGrid>
              <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px">Thank you! </Heading>
              <Text fontSize={theme.fontSize.label} fontWeight={300} color={theme.colors.white}>Your application has been successfully submitted. We’ll notify you on the status of your application within 5 working days.</Text>
            </LeftGrid>
          </FullGrid>
        </ContainerGrid>
      </ContainerBlock>
      <ContainerGrid>
        <LeftGrid>
          <div className={marginTop}></div>
          <Heading>Summary details</Heading>
          <Listing sources={summaries} variant="dash" margin="0 0 30px"/>
          <Divider size={1} color={theme.colors.grey[700]} variant="dashed" margin="0 0 30px" />
          <Heading
            variant="sub"
            fontWeight={600}
            color={theme.colors.grey[400]}
          >
            For any questions related to your policy or complaints, please contact us:
          </Heading>
          <ContactBox items={contactInformation} noDecorator={true} />
          <Text>Any claim matters, please visit <Link text='here' target="_blank" rel="noopener noreferrer" url='https://singlife.com/en/make-a-claim' /> where you can find out more on how to submit a claim.</Text>
        </LeftGrid>


      </ContainerGrid>
    </Container>
  );
};

export default ThankYou;
